import { useReducer, useRef } from 'react';

import { createErrorBoundary, UseErrorBoundaryWrapper } from './create-error-boundary';

export interface UseErrorBoundaryState {
  ErrorBoundary: UseErrorBoundaryWrapper;
  reset: () => void;
}

function useErrorBoundary(): UseErrorBoundaryState {
  const boundaryKeyRef = useRef(0);
  const [, rerender] = useReducer((value: number) => value + 1, 0);
  const errorBoundaryWrapperRef = useRef<UseErrorBoundaryWrapper | null>(null);

  if (errorBoundaryWrapperRef.current === null) {
    errorBoundaryWrapperRef.current = createErrorBoundary(() => boundaryKeyRef.current);
  }

  function reset() {
    boundaryKeyRef.current += 1;
    rerender();
  }

  return {
    ErrorBoundary: errorBoundaryWrapperRef.current,
    reset,
  };
}

export default useErrorBoundary;
